module.exports = __webpack_public_path__ + "img/17-small.2867023a.png";